import { Images } from "../../../types/listingImages";
import { Logo } from "../../../types/logo";
import { ListingVideos } from "../../../types/listingVideos";
import { Assets } from "../../../types/asset-type";
import { ArchiveMedia, PromotionImages } from "../../post/types";
import { ListingType } from "../../../types/userListing";
import { MediaType } from "../../../types/mediaType";

export interface SlideshowProps {
    listingId: string;
    listingType: ListingType;
    images: Images[];
    assets: Assets[];
    isOpen: boolean;
    onClose: () => void;
    formattedAddress: string;
    isGenerating: boolean;
    setIsGenerating: (value: boolean) => void;
    jobId: string | null;
    setJobId: (value: string | null) => void;
    jobStatus: JobStatus | null;
    setJobStatus: (value: JobStatus | null) => void;
    fetchListing: () => void;
    // MB-1490: server-resolved recency claim; undefined (older API) keeps the
    // preview badge ON, only an explicit false hides it.
    recentlyListed?: boolean;
}

export type UnifiedMedia =
    | (Images & {
          mediaType: "image";
          slideshow?: string;
          isProcessing?: boolean;
      })
    | (ListingVideos & {
          mediaType: "video";
          slideshow?: string;
          isProcessing?: boolean;
      })
    | (PromotionImages & {
          mediaType: "image";
          slideshow?: string;
          isProcessing?: boolean;
      })
    | (Assets & {
          mediaType: "image" | "video" | "logo";
          slideshow?: string;
          isProcessing?: boolean;
      })
    | (ArchiveMedia & {
          mediaType: "image" | "video";
          slideshow?: string;
          isProcessing?: boolean;
      });

export interface MediaSelectorProps {
    images?: Images[];
    videos?: ListingVideos[];
    promotionImages?: PromotionImages[];
    assets?: Assets[];
    archived?: ArchiveMedia[];
    selectedMedia: string[];
    onSelect: (id: string) => void;
    maxMedia: number;
    minMedia: number;
    type: MediaType;
    activeTab: "images" | "promotionImages" | "videos" | "assets" | "archived" | "both";
}
export interface PreviewOverlayProps {
    formattedAddress: string;
    newOverlayHasLogo: boolean;
    logoFile: File | null;
    logoUrl: string | null;
    selectedLogo: string | null;
    logos: Logo[];
    theme: "light" | "dark";
    image: string;
}

export interface MusicSelectorProps {
    includeMusic: boolean;
    setIncludeMusic: (value: boolean) => void;
    setLoading: (value: boolean) => void;
    music: MusicType[];
    setMusic: (value: MusicType[]) => void;
    selectedMusic: string;
    setSelectedMusic: (value: string) => void;
}

export interface SlideshowMediaSelectorProps {
    media: SlideshowMedia;
    handleMediaSelect: (id: string, type: "image" | "asset") => void;
    selectedImages: SelectedImages[];
}

interface SlideshowMedia {
    images?: Images[];
    assets?: Assets[];
}

export interface SelectedImages {
    id: string;
    type: "image" | "asset";
}

export enum JobStatus {
    QUEUED = "queued",
    PROCESSING = "processing",
    COMPLETED = "completed",
    FAILED = "failed",
}

export interface MusicType {
    name: string;
    url: string;
}

// A headline / sub-headline pair shown over a slide (Video Micro-Service V2
// `texts` field). Max 30 pairs; ~20 chars per line recommended.
export interface SlideshowText {
    header: string;
    subHeader: string;
    // MB-1314: horizontal crop focus the model chose for this slide; round-trips
    // from generate-text through create so the render crops toward that feature.
    focusPosition?: string;
}
